import type { DecisionToolButtonProps } from "./DecisionToolButton.type";

import { ExportOutlined } from "@ant-design/icons";
import { Button, Form } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SeverityFieldNames } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/constants";
import DecisionToolModal from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/DefectSuggestions/DecisionTool/DecisionToolButton/DecisionToolModal";

const { useFormInstance, useWatch } = Form;
const DecisionToolButton = ({
  visibleDefects,
  disabled,
  isLoading,
  datasetsImage = [],
  ...props
}: DecisionToolButtonProps) => {
  const { t } = useTranslation();
  const form = useFormInstance();
  const selectedMaterial = useWatch(SeverityFieldNames.material, form);
  const [visible, setVisible] = useState(false);

  const onDecisionToolClicked = () => {
    if (disabled) return;
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <>
      <Button
        type="text"
        className="decision-tool-button"
        onClick={onDecisionToolClicked}
        disabled={isLoading || disabled}
        style={{
          cursor: isLoading ? "wait" : disabled ? "not-allowed" : "pointer",
        }}
        {...props}
      >
        <ExportOutlined />
        {t("form:staticField.defectSuggestion.decisionToolHelp")}
      </Button>
      <DecisionToolModal
        visible={visible}
        onCancel={handleClose}
        selectedMaterial={selectedMaterial}
        visibleDefects={visibleDefects}
        datasetsImage={datasetsImage}
        {...props}
      />
    </>
  );
};

export default DecisionToolButton;
